import { Box, BoxProps, useDisclosure } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import useScroll from '~/hooks/useScroll';

export type FixedHeaderSectionProps = {
  children?: React.ReactElement | Array<React.ReactElement> | null;
};
export default function FixedHeaderSection({ children = null }: FixedHeaderSectionProps) {
  const { positionInfo } = useScroll();

  const {
    isOpen: isSectionDisplay,
    onOpen: onSectionOpen,
    onClose: onSectionClose,
  } = useDisclosure({ isOpen: positionInfo.scrollTop >= 400 });

  useEffect(() => {
    if (positionInfo.scrollTop > 400) {
      onSectionOpen();
    } else {
      onSectionClose();
    }
  }, [positionInfo]);

  const handleGoTop = () => {
    window.scrollTo({
      top: 0,
    });
  };

  return (
    <Box
      pos="fixed"
      top={0}
      w="full"
      zIndex={100}
      transition="0.3s"
      transform={`translateY(${isSectionDisplay ? '0' : '-100%'})`}
      onClick={handleGoTop}
      _hover={{
        cursor: 'pointer',
      }}
      bg="white"
      borderBottomColor="primary"
      borderBottomWidth="1px"
    >
      {children}
    </Box>
  );
}
